// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__3eK9D","description":"MealItem_description__3o2_X","price":"MealItem_price__3-DmL"};